import { useState, useEffect } from "react"
import {
    Grid,
    AppBar,
    Tabs,
    Tab,
} from "@material-ui/core"
import EventIcon from '@material-ui/icons/Event';
import HomePage from "../../Home"
import { Container } from "@material-ui/core"
import { useDispatch } from "react-redux"
import { obtenerDevolucionesPendientesAction, obtenerDevolucionesPendientesEstatusAction, obtenerDevolucionesPendientesListadoAction, obtenerDevolucionesPendientesVersionAction } from "../../../ducks/devolucionesDuck"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import TDevoluciones from "../TDevoluciones"
import useCatalogos from "../../../hooks/useCatalogos"
import { catEstatusCatEstatusDevolucion } from "../../../constant/catEstatusDevolucion";
import FiltroDevoluciones from "../FiltroDevoluciones";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    {children}
                </div>
            )}
        </div>
    );
}
function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
}
const VDevoluciones = () => {
    const [value, setValue] = useState(0)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerDevolucionesPendientesAction()).then(Response => {
            dispatch(obtenerDevolucionesPendientesListadoAction())
            dispatch(offLoadAction())
        })
    }, [dispatch])

    const handleClick = ({ estatus }) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerDevolucionesPendientesEstatusAction({ estatus: estatus })).then(Response => {
            dispatch(obtenerDevolucionesPendientesListadoAction())
            dispatch(offLoadAction())
        })
    }

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    return (
        <HomePage>
            <Container maxWidth="xl">
                <Grid container>
                    <Grid item xs={12}>
                        <h3>Devoluciones</h3>
                    </Grid>
                    <Grid item xs={12}>
                        <AppBar position="static" color="secondary">
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons="on"
                                indicatorColor="primary"
                                aria-label="scrollable force tabs example"
                            >
                                <Tab
                                    label={`Pendientes`}
                                    icon={<EventIcon />}
                                    {...a11yProps(0)}
                                    onClick={() => handleClick({ estatus: catEstatusCatEstatusDevolucion.EN_ESPERA })}
                                />
                                <Tab
                                    label={`Realizadas`}
                                    icon={<EventIcon />}
                                    {...a11yProps(0)}
                                    onClick={() => handleClick({ estatus: catEstatusCatEstatusDevolucion.APROBADA })}
                                />
                                <Tab
                                    label={`Rechazadas`}
                                    icon={<EventIcon />}
                                    {...a11yProps(0)}
                                    onClick={() => handleClick({ estatus: catEstatusCatEstatusDevolucion.RECHAZADA })}
                                />
                                <Tab
                                    label={`Rechazadas por finanzas`}
                                    icon={<EventIcon />}
                                    {...a11yProps(0)}
                                    onClick={() => handleClick({ estatus: catEstatusCatEstatusDevolucion.RECHAZADA_FINANZAS })}
                                />
                            </Tabs>
                        </AppBar>
                        <TabPanel value={value} index={0}>
                            <FiltroDevoluciones />
                            <TDevoluciones />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <FiltroDevoluciones />
                            <TDevoluciones />
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <FiltroDevoluciones />
                            <TDevoluciones />
                        </TabPanel>
                        <TabPanel value={value} index={3}>
                            <FiltroDevoluciones />
                            <TDevoluciones />
                        </TabPanel>
                    </Grid>
                </Grid>
            </Container>
        </HomePage>
    )
}
export default VDevoluciones